<template>
  <v-app>
    <div class="liga-background">
      <v-main class="liga-main">
        <!-- CONTEXT BAR (similar al de torneos) -->
        <TorneoContextBar
          :nombre="nombreLiga"
          :categoria="categoriaLiga"
          :tipoCompetencia="tipoCompetenciaLiga"
          :genero="generoLiga"
          :estado="estadoLiga"
          :idTorneo="idLiga"
          :idInstitucion="idInstitucion"
          :hay-cambios-sin-guardar="hayCambiosSinGuardar"
          sistema-competencia="Liga"
          :deporte="deporte"
          @guardar="guardarCambios"
          @volver="volver"
          @cambiarEstado="cambiarEstado"
          @finalizaTorneo="confirmaFinalizacionTorneo"
        />

        <!-- TABS PRINCIPALES -->
        <v-tabs
          v-model="tab"
          grow
          background-color="transparent"
          class="liga-tabs"
        >
          <v-tab>Configuración</v-tab>
          <v-tab :disabled="!liga">Fixture por Fecha</v-tab>
          <v-tab :disabled="!liga">Fixture por Equipo</v-tab>
          <v-tab :disabled="!liga">Tabla de Posiciones</v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
          <!-- TAB 1: CONFIGURACIÓN -->
          <v-tab-item>
            <v-card class="glass-card" elevation="16">
              <v-card-title class="headline">Configurar Liga</v-card-title>
              <v-card-text class="py-4">
                <v-row>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model.number="totalEquipos"
                      type="number"
                      label="Total Equipos"
                      min="2"
                      max="50"
                      outlined
                      hint="Entre 2 y 50 equipos"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" md="6">
                    <v-alert type="info" dense text>
                      <strong>Sistema:</strong> Todos contra todos (Round-Robin)
                    </v-alert>
                  </v-col>
                </v-row>

                <v-row v-if="liga">
                  <v-col cols="12">
                    <v-alert color="success" dark>
                      <strong>Liga generada:</strong>
                      {{ liga.totalEquipos }} equipos,
                      {{ liga.totalFechas }} fechas,
                      {{ calcularTotalPartidos() }} partidos
                    </v-alert>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12">
                    <v-btn
                      class="btn-generar-liga"
                      color="#1976d2"
                      large
                      dark
                      :disabled="estadoLiga === 'Finalizado'"
                      @click="generarLigaClick"
                    >
                      <v-icon left color="white">mdi-trophy</v-icon>
                      {{ liga ? "Re-" : "" }}Generar Liga
                    </v-btn>
                    <span v-if="liga" class="liga-configurada">
                      Liga con configuración activa
                    </span>
                  </v-col>
                </v-row>

                <!-- LISTA DE EQUIPOS -->
                <v-row v-if="liga">
                  <v-col cols="12">
                    <v-card class="mt-4" light>
                      <v-card-title class="subtitle-1">
                        <v-icon left>mdi-account-group</v-icon>
                        Equipos de la Liga
                      </v-card-title>
                      <v-card-text>
                        <v-row>
                          <v-col
                            v-for="equipo in liga.equipos"
                            :key="equipo.id"
                            cols="12"
                            sm="6"
                            md="4"
                            lg="3"
                          >
                            <v-card outlined>
                              <v-card-text
                                class="d-flex justify-space-between align-center"
                              >
                                <div class="flex-grow-1">
                                  <div class="font-weight-medium">
                                    {{ equipo.nombre }}
                                  </div>
                                  <v-chip
                                    v-if="!equipo.ids"
                                    x-small
                                    color="warning"
                                    text-color="white"
                                    class="mt-1"
                                  >
                                    Sin asignar
                                  </v-chip>
                                </div>

                                <!-- MENÚ DROPDOWN -->
                                <v-menu
                                  offset-y
                                  left
                                  :disabled="estadoLiga === 'Finalizado'"
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      icon
                                      small
                                      v-bind="attrs"
                                      v-on="on"
                                      :disabled="estadoLiga === 'Finalizado'"
                                    >
                                      <v-icon small>mdi-dots-vertical</v-icon>
                                    </v-btn>
                                  </template>

                                  <v-list dense>
                                    <!-- FÚTBOL: Editar Nombre -->
                                    <v-list-item
                                      v-if="!usaJugadores"
                                      @click="editarEquipo(equipo)"
                                    >
                                      <v-list-item-icon>
                                        <v-icon small color="primary"
                                          >mdi-pencil</v-icon
                                        >
                                      </v-list-item-icon>
                                      <v-list-item-title>
                                        Editar Nombre del Equipo
                                      </v-list-item-title>
                                    </v-list-item>

                                    <!-- TENIS/PADEL: Asignar Jugadores -->
                                    <v-list-item
                                      v-if="usaJugadores"
                                      @click="editarEquipo(equipo)"
                                    >
                                      <v-list-item-icon>
                                        <v-icon small color="primary"
                                          >mdi-pencil</v-icon
                                        >
                                      </v-list-item-icon>
                                      <v-list-item-title
                                        >Asignar Jugadores</v-list-item-title
                                      >
                                    </v-list-item>

                                    <!-- TENIS/PADEL: Resetear -->
                                    <v-list-item
                                      v-if="usaJugadores"
                                      @click="resetearJugadoresEquipo(equipo)"
                                    >
                                      <v-list-item-icon>
                                        <v-icon small color="warning"
                                          >mdi-account-remove</v-icon
                                        >
                                      </v-list-item-icon>
                                      <v-list-item-title
                                        >Resetear Jugadores</v-list-item-title
                                      >
                                    </v-list-item>
                                  </v-list>
                                </v-menu>
                              </v-card-text>
                            </v-card>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>

          <!-- TAB 2: FIXTURE POR FECHA -->
          <v-tab-item>
            <v-card v-if="liga">
              <v-card-title
                class="headline d-flex justify-space-between align-center"
              >
                <span>Fixture por Fecha</span>

                <!-- Progreso -->
                <v-chip color="primary" dark>
                  {{ progreso.partidosJugados }} /
                  {{ progreso.partidosTotales }} partidos ({{
                    progreso.porcentaje
                  }}%)
                </v-chip>
              </v-card-title>

              <v-card-text>
                <!-- ACCORDION DE FECHAS -->
                <v-expansion-panels v-model="fechaExpandida" accordion>
                  <v-expansion-panel
                    v-for="fecha in liga.fechas"
                    :key="fecha.numero"
                  >
                    <v-expansion-panel-header>
                      <div class="d-flex justify-space-between align-center">
                        <div>
                          <span class="font-weight-bold"
                            >Fecha {{ fecha.numero }}</span
                          >
                          <!-- Mostrar quién descansa -->
                          <v-chip
                            v-if="equipoDescansaEnFecha.get(fecha.numero)"
                            color="grey lighten-2"
                            class="ml-2"
                          >
                            <v-icon left>mdi-sofa</v-icon>
                            Libre:
                            {{ equipoDescansaEnFecha.get(fecha.numero).nombre }}
                          </v-chip>
                        </div>
                        <v-chip small :color="getColorEstadoFecha(fecha)" dark>
                          {{ getEstadoFecha(fecha) }}
                        </v-chip>
                      </div>
                    </v-expansion-panel-header>

                    <v-expansion-panel-content>
                      <v-data-table
                        :headers="headersPartidos"
                        :items="fecha.partidos"
                        class="elevation-1 tabla-partidos"
                        :items-per-page="20"
                        :footer-props="{
                          'items-per-page-options': [10, 20, 50, -1],
                          itemsPerPageText: 'Filas por página',
                        }"
                        :disable-sort="true"
                      >
                        <template v-slot:item.local="{ item }">
                          <span
                            :class="{
                              'ganador-border':
                                item.ganador?.id === item.local?.id,
                              'perdedor-border':
                                item.ganador &&
                                item.ganador.id === item.visitante?.id,
                            }"
                          >
                            {{ item.local.nombre }}
                          </span>
                        </template>

                        <template v-slot:item.vs>
                          <span>vs</span>
                        </template>

                        <template v-slot:item.visitante="{ item }">
                          <span
                            :class="{
                              'ganador-border':
                                item.ganador?.id === item.visitante?.id,
                              'perdedor-border':
                                item.ganador &&
                                item.ganador.id === item.local?.id,
                            }"
                          >
                            {{ item.visitante.nombre }}
                          </span>
                        </template>

                        <template v-slot:item.detalles="{ item }">
                          <div
                            v-if="item.detalles && tieneDetalles(item.detalles)"
                          >
                            <v-chip
                              v-if="item.detalles.fecha"
                              x-small
                              class="mr-1 mb-1"
                              color="indigo"
                              dark
                            >
                              📅 {{ item.detalles.fecha }}
                            </v-chip>
                            <v-chip
                              v-if="item.detalles.hora"
                              x-small
                              class="mr-1 mb-1"
                              color="indigo"
                              dark
                            >
                              ⏰ {{ item.detalles.hora }}
                            </v-chip>
                            <v-chip
                              v-if="item.detalles.lugar"
                              x-small
                              class="mr-1 mb-1"
                              color="indigo"
                              dark
                            >
                              📍 {{ item.detalles.lugar }}
                            </v-chip>
                          </div>
                          <span v-else class="text-caption grey--text"
                            >Sin detalles</span
                          >
                        </template>

                        <template v-slot:item.resultado="{ item }">
                          <span v-if="item.resultado">{{
                            item.resultado
                          }}</span>
                          <span v-else class="grey--text">—</span>
                        </template>

                        <template v-slot:item.estado="{ item }">
                          <v-chip v-if="item.resultado" color="success" small>
                            <v-icon left small>mdi-check</v-icon>
                            Jugado
                          </v-chip>
                          <v-chip v-else color="warning" small>
                            <v-icon left small>mdi-clock</v-icon>
                            Pendiente
                          </v-chip>
                        </template>

                        <template v-slot:item.actions="{ item }">
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                small
                                color="primary"
                                @click="abrirModalDetalles(item)"
                                :disabled="estadoLiga === 'Finalizado'"
                                v-bind="attrs"
                                v-on="on"
                                class="mr-1"
                              >
                                <v-icon small>mdi-calendar</v-icon>
                              </v-btn>
                            </template>
                            <span>Cargar Detalles</span>
                          </v-tooltip>

                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                small
                                color="success"
                                @click="abrirModalResultado(item)"
                                :disabled="estadoLiga === 'Finalizado'"
                                v-bind="attrs"
                                v-on="on"
                              >
                                <v-icon small>mdi-soccer</v-icon>
                              </v-btn>
                            </template>
                            <span>Cargar Resultado</span>
                          </v-tooltip>
                        </template>
                      </v-data-table>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-card-text>
            </v-card>

            <v-alert v-else type="info" class="mt-4">
              <v-icon left>mdi-information</v-icon>
              Primero debe generar una liga desde la pestaña "Configuración"
            </v-alert>
          </v-tab-item>

          <!-- TAB 3: FIXTURE POR EQUIPO -->
          <v-tab-item>
            <v-card v-if="liga">
              <v-card-title class="headline">Fixture por Equipo</v-card-title>

              <v-card-text>
                <!-- SELECTOR DE EQUIPO -->
                <v-row>
                  <v-col cols="12" md="6">
                    <v-select
                      v-model="equipoSeleccionado"
                      :items="liga.equipos"
                      item-text="nombre"
                      item-value="id"
                      label="Seleccionar Equipo"
                      outlined
                      dense
                    >
                      <template v-slot:item="{ item }">
                        <v-list-item-content>
                          <v-list-item-title>{{
                            item.nombre
                          }}</v-list-item-title>
                        </v-list-item-content>
                      </template>
                    </v-select>
                  </v-col>
                </v-row>

                <!-- PARTIDOS DEL EQUIPO -->
                <div v-if="equipoSeleccionado">
                  <v-data-table
                    :headers="headersPartidosEquipo"
                    :items="partidosDelEquipo"
                    class="elevation-1"
                    :items-per-page="20"
                    :footer-props="{
                      'items-per-page-options': [10, 20, 50, -1],
                      itemsPerPageText: 'Filas por página',
                    }"
                  >
                    <template v-slot:item.fecha="{ item }">
                      <v-chip small color="primary" dark>
                        Fecha {{ item.fecha }}
                      </v-chip>
                    </template>

                    <template v-slot:item.rival="{ item }">
                      <div>
                        <span v-if="item.local.id === equipoSeleccionado">
                          vs {{ item.visitante.nombre }}
                        </span>
                        <span v-else> vs {{ item.local.nombre }} </span>

                        <v-chip
                          x-small
                          :color="
                            item.local.id === equipoSeleccionado
                              ? 'blue'
                              : 'orange'
                          "
                          dark
                          class="ml-2"
                        >
                          {{
                            item.local.id === equipoSeleccionado
                              ? "Local"
                              : "Visitante"
                          }}
                        </v-chip>
                      </div>
                    </template>

                    <template v-slot:item.detalles="{ item }">
                      <div v-if="item.detalles && tieneDetalles(item.detalles)">
                        <v-chip
                          v-if="item.detalles.fecha"
                          x-small
                          class="mr-1 mb-1"
                          color="indigo"
                          dark
                        >
                          📅 {{ item.detalles.fecha }}
                        </v-chip>
                        <v-chip
                          v-if="item.detalles.hora"
                          x-small
                          class="mr-1 mb-1"
                          color="indigo"
                          dark
                        >
                          ⏰ {{ item.detalles.hora }}
                        </v-chip>
                        <v-chip
                          v-if="item.detalles.lugar"
                          x-small
                          class="mr-1 mb-1"
                          color="indigo"
                          dark
                        >
                          📍 {{ item.detalles.lugar }}
                        </v-chip>
                      </div>
                      <span v-else class="text-caption grey--text"
                        >Sin detalles</span
                      >
                    </template>

                    <template v-slot:item.resultado="{ item }">
                      <div v-if="item.resultado">
                        <span :class="getClaseResultado(item)">
                          {{ item.resultado }}
                        </span>
                      </div>
                      <span v-else class="grey--text">Pendiente</span>
                    </template>

                    <template v-slot:item.estado="{ item }">
                      <v-chip small :color="getColorResultadoEquipo(item)" dark>
                        {{ getEstadoPartidoEquipo(item) }}
                      </v-chip>
                    </template>

                    <template v-slot:item.actions="{ item }">
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            small
                            color="primary"
                            @click="abrirModalDetalles(item)"
                            :disabled="estadoLiga === 'Finalizado'"
                            v-bind="attrs"
                            v-on="on"
                            class="mr-1"
                          >
                            <v-icon small>mdi-calendar</v-icon>
                          </v-btn>
                        </template>
                        <span>Cargar Detalles</span>
                      </v-tooltip>

                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            small
                            color="success"
                            @click="abrirModalResultado(item)"
                            :disabled="estadoLiga === 'Finalizado'"
                            v-bind="attrs"
                            v-on="on"
                          >
                            <v-icon small>mdi-soccer</v-icon>
                          </v-btn>
                        </template>
                        <span>Cargar Resultado</span>
                      </v-tooltip>
                    </template>
                  </v-data-table>

                  <!-- RESUMEN DEL EQUIPO -->
                  <v-row class="mt-4">
                    <v-col cols="12" md="3">
                      <v-card color="primary" dark>
                        <v-card-text class="text-center">
                          <div class="text-h4">
                            {{ getEstadisticaEquipo("pj") }}
                          </div>
                          <div>Partidos Jugados</div>
                        </v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-card color="success" dark>
                        <v-card-text class="text-center">
                          <div class="text-h4">
                            {{ getEstadisticaEquipo("pg") }}
                          </div>
                          <div>Ganados</div>
                        </v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-card color="error" dark>
                        <v-card-text class="text-center">
                          <div class="text-h4">
                            {{ getEstadisticaEquipo("pp") }}
                          </div>
                          <div>Perdidos</div>
                        </v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-card color="amber darken-2" dark>
                        <v-card-text class="text-center">
                          <div class="text-h4">
                            {{ getEstadisticaEquipo("puntos") }}
                          </div>
                          <div>Puntos</div>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </div>

                <v-alert v-else type="info" text class="mt-4">
                  Seleccione un equipo para ver su fixture
                </v-alert>
              </v-card-text>
            </v-card>

            <v-alert v-else type="info" class="mt-4">
              <v-icon left>mdi-information</v-icon>
              Primero debe generar una liga desde la pestaña "Configuración"
            </v-alert>
          </v-tab-item>

          <!-- TAB 4: TABLA DE POSICIONES -->
          <v-tab-item>
            <v-card v-if="liga">
              <v-card-title class="headline">
                Tabla de Posiciones

                <v-spacer></v-spacer>

                <v-btn
                  v-if="
                    estadoLiga !== 'Finalizado' && progreso.porcentaje === 100
                  "
                  color="success"
                  @click="abrirModalFinalizar"
                >
                  <v-icon left>mdi-flag-checkered</v-icon>
                  Finalizar Liga
                </v-btn>

                <v-spacer></v-spacer>

                <v-chip color="info" dark>
                  Progreso: {{ progreso.porcentaje }}%
                </v-chip>
              </v-card-title>

              <v-card-text>
                <v-simple-table class="tabla-posiciones elevation-2">
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">#</th>
                        <th class="text-left">Equipo</th>
                        <th class="text-center">PJ</th>
                        <th class="text-center">PG</th>
                        <!-- ⭐ NUEVO: Columna PE solo para fútbol -->
                        <th v-if="deporte === 'Futbol'" class="text-center">
                          PE
                        </th>
                        <th class="text-center">PP</th>
                        <!-- ⭐ CONDICIONAL: Sets solo si NO es fútbol -->
                        <th v-if="deporte !== 'Futbol'" class="text-center">
                          Sets +/-
                        </th>
                        <!-- ⭐ ADAPTATIVO: Goles para fútbol, Games para tenis/padel -->
                        <th class="text-center">
                          {{ deporte === "Futbol" ? "Goles" : "Games" }} +/-
                        </th>
                        <th class="text-center">Pts</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(fila, index) in tablaPosiciones"
                        :key="fila.equipo.id"
                      >
                        <td class="text-left">{{ index + 1 }}</td>
                        <td class="text-left">{{ fila.equipo.nombre }}</td>
                        <td class="text-center">{{ fila.pj }}</td>
                        <td class="text-center">{{ fila.pg }}</td>
                        <!-- ⭐ NUEVO -->
                        <td v-if="deporte === 'Futbol'" class="text-center">
                          {{ fila.pe }}
                        </td>
                        <td class="text-center">{{ fila.pp }}</td>
                        <td v-if="deporte !== 'Futbol'" class="text-center">
                          {{ fila.setsDiff > 0 ? "+" : "" }}{{ fila.setsDiff }}
                        </td>
                        <td class="text-center">
                          {{ fila.gamesDiff > 0 ? "+" : ""
                          }}{{ fila.gamesDiff }}
                        </td>
                        <td class="text-center">
                          <strong>{{ fila.puntos }}</strong>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>

                <!-- LEYENDA -->
                <v-row class="mt-4">
                  <v-col cols="12">
                    <v-card outlined>
                      <v-card-text>
                        <div class="text-subtitle-2 mb-2">Leyenda:</div>
                        <div class="d-flex flex-wrap">
                          <v-chip x-small class="mr-2 mb-1"
                            >PJ: Partidos Jugados</v-chip
                          >
                          <v-chip x-small class="mr-2 mb-1"
                            >PG: Partidos Ganados</v-chip
                          >
                          <!-- ⭐ CONDICIONAL -->
                          <v-chip
                            v-if="deporte === 'Futbol'"
                            x-small
                            class="mr-2 mb-1"
                          >
                            PE: Partidos Empatados
                          </v-chip>
                          <v-chip x-small class="mr-2 mb-1"
                            >PP: Partidos Perdidos</v-chip
                          >
                          <v-chip
                            v-if="deporte !== 'Futbol'"
                            x-small
                            class="mr-2 mb-1"
                          >
                            Sets +/-: Diferencia de Sets
                          </v-chip>
                          <v-chip x-small class="mr-2 mb-1">
                            {{ deporte === "Futbol" ? "Goles" : "Games" }} +/-:
                            Diferencia de
                            {{ deporte === "Futbol" ? "Goles" : "Games" }}
                          </v-chip>
                          <v-chip x-small class="mr-2 mb-1">
                            Pts: Puntos (Victoria = 3 pts{{
                              deporte === "Futbol" ? ", Empate = 1 pt" : ""
                            }})
                          </v-chip>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>

            <v-alert v-else type="info" class="mt-4">
              <v-icon left>mdi-information</v-icon>
              Primero debe generar una liga desde la pestaña "Configuración"
            </v-alert>
          </v-tab-item>
        </v-tabs-items>

        <v-btn dark color="#24232d" class="mt-8 mb-4" @click="volver">
          <v-icon left>mdi-arrow-left</v-icon>
          Volver
        </v-btn>
      </v-main>
    </div>

    <!-- MODALES -->
    <editar-detalles-partido
      :visible="modalDetallesVisible"
      :partido="partidoActivo"
      :proxy="proxy"
      @close="closeModalDetalles"
      @save="guardarDetalles"
    />

    <cargar-resultado
      :partido="partidoActivo"
      :visible="modalResultadoVisible"
      :proxy="proxy"
      :deporte="deporte"
      @close="closeModalResultado"
      @save="guardarResultado"
    />

    <asignar-jugadores
      v-if="modalAsignarJugadoresVisible"
      :visible="modalAsignarJugadoresVisible"
      :tipo-competencia="tipoCompetenciaLiga"
      :proxy="proxy"
      :id-torneo="idLiga"
      :ids="equipoActivo?.ids"
      :ids-usados="obtenerIdsJugadoresUsados(equipoActivo)"
      :info-torneo="infoLiga"
      @close="modalAsignarJugadoresVisible = false"
      @save="asignarJugadoresAEquipoActivo"
    />

    <asignar-nombre-equipo
      v-if="!usaJugadores && modalAsignarNombreVisible"
      :visible="modalAsignarNombreVisible"
      :nombre-actual="equipoActivo?.nombre"
      @close="modalAsignarNombreVisible = false"
      @save="asignarNombreEquipoLiga"
    />

    <modal-finalizar-competencia
      :visible="modalFinalizarVisible"
      :jugadores="jugadoresFinales"
      tipo-competencia="Liga"
      :nombre-competencia="nombreLiga"
      :categoria="categoriaLiga"
      :genero="generoLiga"
      @close="modalFinalizarVisible = false"
      @finalizar="finalizarTorneo"
    />
  </v-app>
</template>

<script lang="ts" setup>
import { calcularGanador } from "@/utils/resultados";
import { getConfigDeporte, type Deporte } from "@/utils/deportes-config";
import AsignarNombreEquipo from "./AsignarNombreEquipo.vue";

import {
  ref,
  computed,
  nextTick,
  getCurrentInstance,
  onMounted,
  onUnmounted,
  watch,
} from "vue";
import {
  generarLiga,
  calcularTablaPosiciones,
  obtenerPartidosDeEquipo,
  obtenerProgresoLiga,
  obtenerEquipoDescansoPorFecha,
  type Liga,
  type PartidoLiga,
  type EstadisticasEquipo,
} from "../../utils/ligas";
import CargarResultado from "./CargarResultado.vue";
import EditarDetallesPartido from "./EditarDetallesPartido.vue";
import TorneoContextBar from "./TorneoContextBar.vue";
import AsignarJugadores from "./AsignarJugadores.vue";
import { showAlert, confirmModal } from "@/utils/toast";
import axios from "@/axios-auth";
import ModalFinalizarCompetencia from "./ModalFinalizarCompetencia.vue";
import {
  obtenerJugadoresOrdenadosLiga,
  puedeFinalizarLiga,
  type JugadorParaFinalizar,
} from "@/utils/rankings";

const { proxy } = getCurrentInstance();

const deporte = ref<Deporte>("Futbol");

// Referencias reactivas
const totalEquipos = ref(4);
const liga = ref<Liga | null>(null);
const ligaOriginal = ref<any>(null);
const tab = ref(0);
const fechaExpandida = ref<number | undefined>(undefined);
const equipoSeleccionado = ref<number | null>(null);

const guardarInterval = ref();

const modalDetallesVisible = ref(false);
const modalResultadoVisible = ref(false);
const modalAsignarJugadoresVisible = ref(false);
const modalAsignarNombreVisible = ref(false);

const partidoActivo = ref<any>(null);
const equipoActivo = ref<any>(null);

const nombreLiga = ref("");
const categoriaLiga = ref("");
const generoLiga = ref("");
const tipoCompetenciaLiga = ref("");
const estadoLiga = ref("Draft");
const idLiga = ref();
const idInstitucion = ref();
const infoLiga = ref("");
const hayCambiosSinGuardar = ref(false);

// Agregar refs
const modalFinalizarVisible = ref(false);
const jugadoresFinales = ref<JugadorParaFinalizar[]>([]);

const configDeporte = computed(() => getConfigDeporte(deporte.value));
const usaJugadores = computed(() => configDeporte.value.usaJugadores);
// Headers para las tablas
const headersPartidos = computed(() => [
  { text: "Partido", value: "id", sortable: false, width: "80px" },
  { text: "Local", value: "local", sortable: false, width: "25%" },
  { text: "VS", value: "vs", sortable: false, width: "50px" },
  { text: "Visitante", value: "visitante", sortable: false, width: "25%" },
  { text: "Detalles", value: "detalles", sortable: false },
  { text: "Resultado", value: "resultado", sortable: false },
  { text: "Estado", value: "estado", sortable: false },
  { text: "Acciones", value: "actions", sortable: false },
]);

const headersPartidosEquipo = computed(() => [
  { text: "Fecha", value: "fecha", sortable: true },
  { text: "Rival", value: "rival", sortable: false, width: "25%" },
  { text: "Detalles", value: "detalles", sortable: false },
  { text: "Resultado", value: "resultado", sortable: false },
  { text: "Estado", value: "estado", sortable: false },
  { text: "Acciones", value: "actions", sortable: false },
]);

// Computed properties
const tablaPosiciones = computed(() => {
  if (!liga.value) return [];
  return calcularTablaPosiciones(liga.value);
});

const progreso = computed(() => {
  if (!liga.value)
    return { partidosJugados: 0, partidosTotales: 0, porcentaje: 0 };
  return obtenerProgresoLiga(liga.value);
});

const partidosDelEquipo = computed(() => {
  if (!liga.value || !equipoSeleccionado.value) return [];
  return obtenerPartidosDeEquipo(liga.value, equipoSeleccionado.value);
});

const equipoDescansaEnFecha = computed(() => {
  if (!liga.value) return new Map();
  return obtenerEquipoDescansoPorFecha(liga.value);
});

// Funciones de generación
function calcularTotalPartidos(): number {
  if (!liga.value) return 0;
  return liga.value.fechas.reduce(
    (total, fecha) => total + fecha.partidos.length,
    0,
  );
}

async function generarLigaClick() {
  if (estadoLiga.value === "Publicado") {
    showAlert({
      icon: "warning",
      title:
        "La liga ya está publicada. Vuelva a ponerla en estado Draft para regenerar.",
      timer: 4000,
      vm: proxy,
    });
    return;
  }

  if (totalEquipos.value < 2 || totalEquipos.value > 50) {
    showAlert({
      icon: "warning",
      title: "El número de equipos debe estar entre 2 y 50.",
      timer: 4000,
      vm: proxy,
    });
    return;
  }

  if (progreso.value.partidosJugados > 0) {
    const result = await confirmModal({
      vm: proxy,
      title: "Liga con resultados",
      text: "Hay resultados cargados. Si regenera la liga, se perderán. ¿Desea continuar?",
      icon: "warning",
      showCancelButton: true,
      showCloseButton: true,
    });

    if (!result.isConfirmed) return;
  }

  try {
    liga.value = generarLiga(totalEquipos.value, deporte.value);

    await guardarCambios();

    showAlert({
      icon: "success",
      title: "Liga generada exitosamente!",
      timer: 2500,
      vm: proxy,
    });

    // Cambiar a la pestaña de fixture
    tab.value = 1;
  } catch (error) {
    showAlert({
      icon: "error",
      title: error.message || "Error al generar la liga",
      timer: 4000,
      vm: proxy,
    });
  }
}

// Funciones de estado
function getEstadoFecha(fecha: any): string {
  const partidosJugados = fecha.partidos.filter((p: any) => p.resultado).length;
  const totalPartidos = fecha.partidos.length;

  if (partidosJugados === 0) return "Pendiente";
  if (partidosJugados === totalPartidos) return "Completa";
  return `${partidosJugados}/${totalPartidos}`;
}

function getColorEstadoFecha(fecha: any): string {
  const partidosJugados = fecha.partidos.filter((p: any) => p.resultado).length;
  const totalPartidos = fecha.partidos.length;

  if (partidosJugados === 0) return "warning";
  if (partidosJugados === totalPartidos) return "success";
  return "info";
}

function tieneDetalles(detalles: any): boolean {
  if (!detalles) return false;
  return !!(
    detalles.fecha ||
    detalles.hora ||
    detalles.lugar ||
    detalles.observaciones
  );
}

function getClaseResultado(partido: any): string {
  if (!partido.ganador) return "";

  const esLocal = partido.local.id === equipoSeleccionado.value;
  const gano = partido.ganador.id === equipoSeleccionado.value;

  return gano ? "ganador-resultado" : "perdedor-resultado";
}

function getColorResultadoEquipo(partido: any): string {
  if (!partido.ganador) return "grey";

  const gano = partido.ganador.id === equipoSeleccionado.value;
  return gano ? "success" : "error";
}

function getEstadoPartidoEquipo(partido: any): string {
  if (!partido.ganador) return "Pendiente";

  const gano = partido.ganador.id === equipoSeleccionado.value;
  return gano ? "Victoria" : "Derrota";
}

function getEstadisticaEquipo(campo: string): number {
  if (!equipoSeleccionado.value || !tablaPosiciones.value) return 0;

  const stats = tablaPosiciones.value.find(
    (s: EstadisticasEquipo) => s.equipo.id === equipoSeleccionado.value,
  );

  return stats ? (stats[campo as keyof EstadisticasEquipo] as number) : 0;
}

async function confirmaFinalizacionTorneo() {
  const result = await confirmModal({
    vm: proxy,
    title: "Finalizar liga.",
    text: "¿Está seguro que desea finalizar la liga? Esta acción no se puede deshacer.",
    icon: "warning",
    showCancelButton: true,
    showCloseButton: true,
  });

  if (!result.isConfirmed) {
    return;
  }

  abrirModalFinalizar();
}

function getClaseDiferencia(valor: number): string {
  if (valor > 0) return "success--text font-weight-bold";
  if (valor < 0) return "error--text font-weight-bold";
  return "";
}

// Funciones de modales
function abrirModalDetalles(partido: any) {
  partidoActivo.value = partido;
  modalDetallesVisible.value = true;
}

function closeModalDetalles() {
  modalDetallesVisible.value = false;
  partidoActivo.value = null;
}

function guardarDetalles(detalles: any) {
  if (!partidoActivo.value) return;

  if (!partidoActivo.value.detalles) {
    partidoActivo.value.detalles = {};
  }

  partidoActivo.value.detalles = {
    ...partidoActivo.value.detalles,
    ...detalles,
  };

  Object.keys(partidoActivo.value.detalles).forEach((key) => {
    if (!partidoActivo.value.detalles[key]) {
      delete partidoActivo.value.detalles[key];
    }
  });

  closeModalDetalles();
}

function abrirModalResultado(partido: any) {
  if (!partido.local || !partido.visitante) {
    showAlert({
      icon: "warning",
      title: "Este partido no tiene participantes definidos.",
      timer: 4000,
      vm: proxy,
    });
    return;
  }

  partidoActivo.value = partido;
  modalResultadoVisible.value = true;
}

function closeModalResultado() {
  modalResultadoVisible.value = false;
  partidoActivo.value = null;
}

function guardarResultado(modalSets: any) {
  if (!liga.value || !partidoActivo.value) return;

  const deporteActual = deporte.value;
  const config = getConfigDeporte(deporteActual);

  // VALIDAR según configuración
  if (modalSets.length < config.minimosResultados) {
    showAlert({
      icon: "warning",
      title: `Se necesitan mínimo ${config.minimosResultados} ${
        config.unidadPrincipal
      }${config.minimosResultados > 1 ? "s" : ""}.`,
      timer: 4000,
      vm: proxy,
    });
    return;
  }

  // Validar valores
  for (const s of modalSets) {
    if (
      !Number.isInteger(s.gamesLocal) ||
      !Number.isInteger(s.gamesVisitante) ||
      s.gamesLocal < 0 ||
      s.gamesVisitante < 0
    ) {
      showAlert({
        icon: "warning",
        title: `Debe completar todos los ${config.unidadSecundaria} con números válidos.`,
        timer: 4000,
        vm: proxy,
      });
      return;
    }
  }

  // Calcular ganador usando utilidad
  const { ganador, resultado } = calcularGanador(
    modalSets,
    partidoActivo.value.local,
    partidoActivo.value.visitante,
    deporteActual,
  );

  // Guardar
  partidoActivo.value.sets = modalSets.map((s: any) => ({
    gamesLocal: Number(s.gamesLocal),
    gamesVisitante: Number(s.gamesVisitante),
  }));

  partidoActivo.value.ganador = ganador;
  partidoActivo.value.resultado = resultado;

  modalResultadoVisible.value = false;
  partidoActivo.value = null;

  showAlert({
    icon: "success",
    title: "Resultado guardado correctamente.",
    timer: 2500,
    vm: proxy,
  });
}

// Funciones de equipos
function editarEquipo(equipo: any) {
  if (estadoLiga.value === "Publicado") {
    showAlert({
      icon: "warning",
      title: "La liga ya está publicada. Vuelva a ponerla en estado Draft.",
      timer: 5000,
      vm: proxy,
    });
    return;
  }

  equipoActivo.value = equipo;

  // Determinar qué modal abrir según el deporte
  if (!usaJugadores.value) {
    // FÚTBOL: Solo editar nombre
    modalAsignarNombreVisible.value = true;
  } else {
    // TENIS/PADEL: Asignar jugadores
    modalAsignarJugadoresVisible.value = true;
  }
}

function asignarNombreEquipoLiga(nombre: string) {
  if (!equipoActivo.value) return;

  const equipoId = equipoActivo.value.id;

  // 1. Actualizar en el array de equipos
  equipoActivo.value.nombre = nombre;

  // 2. PROPAGAR A TODOS LOS PARTIDOS
  if (liga.value) {
    liga.value.fechas.forEach((fecha: any) => {
      fecha.partidos.forEach((partido: any) => {
        // Actualizar en local
        if (partido.local && partido.local.id === equipoId) {
          partido.local.nombre = nombre;
          // También actualizar el ganador si corresponde
          if (partido.ganador && partido.ganador.id === equipoId) {
            partido.ganador.nombre = nombre;
          }
        }

        // Actualizar en visitante
        if (partido.visitante && partido.visitante.id === equipoId) {
          partido.visitante.nombre = nombre;
          // También actualizar el ganador si corresponde
          if (partido.ganador && partido.ganador.id === equipoId) {
            partido.ganador.nombre = nombre;
          }
        }
      });
    });
  }

  hayCambiosSinGuardar.value = true;
  modalAsignarNombreVisible.value = false;
  equipoActivo.value = null;

  showAlert({
    icon: "success",
    title: `Nombre actualizado: ${nombre}`,
    timer: 2500,
    vm: proxy,
  });
}

async function resetearJugadoresEquipo(equipo: any) {
  // Solo para tenis/padel
  if (!usaJugadores.value) {
    return;
  }

  if (estadoLiga.value === "Publicado") {
    showAlert({
      icon: "warning",
      title: "La liga ya está publicada.",
      timer: 5000,
      vm: proxy,
    });
    return;
  }

  const result = await confirmModal({
    vm: proxy,
    title: "Resetear jugadores",
    text: `¿Está seguro que desea resetear los jugadores del equipo "${equipo.nombre}"?`,
    icon: "warning",
    showCancelButton: true,
    showCloseButton: true,
    confirmButtonText: "Sí, resetear",
    cancelButtonText: "Cancelar",
  });

  if (!result.isConfirmed) return;

  const equipoId = equipo.id;
  const nombrePorDefecto = `Equipo ${equipo.id}`;

  // Resetear
  equipo.nombre = nombrePorDefecto;
  delete equipo.ids;

  // Propagar a todos los partidos (igual que antes)
  if (liga.value && equipoId) {
    liga.value.fechas.forEach((fecha: any) => {
      fecha.partidos.forEach((partido: any) => {
        if (partido.local && partido.local.id === equipoId) {
          partido.local.nombre = nombrePorDefecto;
          if (partido.ganador && partido.ganador.id === equipoId) {
            partido.ganador.nombre = nombrePorDefecto;
          }
        }

        if (partido.visitante && partido.visitante.id === equipoId) {
          partido.visitante.nombre = nombrePorDefecto;
          if (partido.ganador && partido.ganador.id === equipoId) {
            partido.ganador.nombre = nombrePorDefecto;
          }
        }
      });
    });
  }

  hayCambiosSinGuardar.value = true;

  showAlert({
    icon: "success",
    title: "Jugadores reseteados correctamente.",
    timer: 2500,
    vm: proxy,
  });
}

function asignarJugadoresAEquipoActivo(jugadores: any) {
  const splitJugador1 = jugadores.jugador1.value.nombreJugador.split(",");
  const nombreJugador1 =
    splitJugador1[0] + " " + splitJugador1[1].trim().substr(0, 1) + ".";
  const idJugador1 = jugadores.jugador1.value.idJugador;

  let nombreJugador2 = "";
  let idJugador2 = null;

  if (tipoCompetenciaLiga.value === "Dobles") {
    const splitJugador2 = jugadores.jugador2.value.nombreJugador.split(",");
    nombreJugador2 =
      splitJugador2[0] + " " + splitJugador2[1].trim().substr(0, 1) + ".";
    idJugador2 = jugadores.jugador2.value.idJugador;
  }

  let nombreEquipo = nombreJugador1;

  if (tipoCompetenciaLiga.value === "Dobles") {
    nombreEquipo += ` - ${nombreJugador2}`;
  }

  const ids = { idJugador1, idJugador2 };

  if (ids.idJugador2 == null) {
    delete ids.idJugador2;
  }

  // Guardar el ID del equipo
  const equipoId = equipoActivo.value?.id;

  // 1. Actualizar el equipo en el array de equipos
  if (equipoActivo.value) {
    equipoActivo.value.nombre = nombreEquipo;
    equipoActivo.value.ids = ids;
  }

  // 2. PROPAGAR A TODOS LOS PARTIDOS (igual que en asignarNombreEquipoLiga)
  if (liga.value && equipoId) {
    liga.value.fechas.forEach((fecha: any) => {
      fecha.partidos.forEach((partido: any) => {
        if (partido.local && partido.local.id === equipoId) {
          partido.local.nombre = nombreEquipo;
          if (partido.ganador && partido.ganador.id === equipoId) {
            partido.ganador.nombre = nombreEquipo;
          }
        }

        if (partido.visitante && partido.visitante.id === equipoId) {
          partido.visitante.nombre = nombreEquipo;
          if (partido.ganador && partido.ganador.id === equipoId) {
            partido.ganador.nombre = nombreEquipo;
          }
        }
      });
    });
  }

  hayCambiosSinGuardar.value = true;
  modalAsignarJugadoresVisible.value = false;
  equipoActivo.value = null;

  showAlert({
    icon: "success",
    title: "Jugadores asignados correctamente en todos los partidos.",
    timer: 2500,
    vm: proxy,
  });
}

function obtenerIdsJugadoresUsados(equipoExcluido?: any): number[] {
  const idsUsados: number[] = [];

  if (!liga.value) return idsUsados;

  liga.value.equipos.forEach((equipo: any) => {
    // Excluir el equipo que estamos editando
    if (equipoExcluido && equipo.id === equipoExcluido.id) return;

    if (equipo.ids) {
      if (equipo.ids.idJugador1) {
        idsUsados.push(equipo.ids.idJugador1);
      }
      if (equipo.ids.idJugador2) {
        idsUsados.push(equipo.ids.idJugador2);
      }
    }
  });

  return [...new Set(idsUsados)];
}

// Funciones de navegación y guardado
function cambiarEstado(estado: string) {
  estadoLiga.value = estado;
}

async function guardarCambios() {
  if (liga.value) {
    ligaOriginal.value = JSON.parse(JSON.stringify(liga.value));
    hayCambiosSinGuardar.value = false;

    const ligaGuardar = {
      idTorneo: idLiga.value,
      configuraciones: JSON.stringify(liga.value),
      idInstitucion: idInstitucion.value,
    };

    try {
      await axios.post("/Torneos/ModificarConfiguraciones", ligaGuardar);

      showAlert({
        icon: "success",
        title: "Cambios guardados correctamente.",
        timer: 2500,
        vm: proxy,
      });
    } catch (error) {
      showAlert({
        icon: "error",
        title: "Error al guardar los cambios.",
        timer: 4000,
        vm: proxy,
      });
    }
  }
}

async function volver() {
  if (hayCambiosSinGuardar.value) {
    const result = await confirmModal({
      vm: proxy,
      title: "Cambios sin guardar.",
      text: "Posee cambios sin guardar.",
      icon: "warning",
      showCancelButton: true,
      showCloseButton: true,
      cancelButtonText: "Volver",
      confirmButtonText: "Guardar y volver",
    });

    if (result.isConfirmed) {
      await guardarCambios();
    }
  }

  proxy.$router.push("/lista-competiciones");
}

// Función para abrir modal
async function abrirModalFinalizar() {
  const validacion = puedeFinalizarLiga(liga.value, progreso.value);

  if (!validacion.puede) {
    showAlert({
      icon: "warning",
      title: "No se puede finalizar",
      text: validacion.razon,
      timer: 4000,
      vm: proxy,
    });
    return;
  }

  jugadoresFinales.value = obtenerJugadoresOrdenadosLiga(
    liga.value,
    tablaPosiciones.value,
    nombreLiga.value,
    categoriaLiga.value,
    generoLiga.value,
  );

  if (jugadoresFinales.value.length === 0) {
    showAlert({
      icon: "warning",
      title: "Sin jugadores asignados",
      text: "No hay jugadores con asignación válida en este torneo.",
      timer: 4000,
      vm: proxy,
    });
    const datosTorneo = {
      nombre: "",
      descripcion: "",
      genero: null,
      categoria: null,
      fecha: "01/01/2025",
      tipoCompetencia: null,
      estado: "Finalizado",
      configuraciones: "",
      idTorneo: idLiga.value,
      idInstitucion: proxy.$store.state.usuario.institucion.idInstitucion,
    };

    await axios.post("/Torneos/CambiarEstado", datosTorneo);

    await guardarCambios();

    cambiarEstado("Finalizado");
    return;
  }

  modalFinalizarVisible.value = true;
}

// Función para finalizar
async function finalizarTorneo(jugadores: JugadorParaFinalizar[]) {
  try {
    const payload = {
      idTorneo: idLiga.value,
      jugadores: JSON.stringify(
        jugadores.map((j) => ({
          idJugador: j.idJugador,
          nombreJugador: j.nombreJugador,
          posicion: j.ordenMerito,
          puntosAsignados: j.puntosAsignados,
        })),
      ),
      idInstitucion: proxy.$store.state.usuario.institucion.idInstitucion,
    };

    await axios.post("/Ranking/GuardarRanking", payload);

    const datosTorneo = {
      nombre: "",
      descripcion: "",
      genero: null,
      categoria: null,
      fecha: "01/01/2025",
      tipoCompetencia: null,
      estado: "Finalizado",
      configuraciones: "",
      idTorneo: idLiga.value,
      idInstitucion: proxy.$store.state.usuario.institucion.idInstitucion,
    };

    await axios.post("/Torneos/CambiarEstado", datosTorneo);

    await guardarCambios();

    cambiarEstado("Finalizado");

    modalFinalizarVisible.value = false;

    showAlert({
      icon: "success",
      title: "Liga Finalizada!",
      text: "Los puntos han sido asignados correctamente.",
      timer: 3000,
      vm: proxy,
    });
  } catch (error) {
    showAlert({
      icon: "error",
      title: "Error",
      text: "No se pudo finalizar la liga.",
      timer: 4000,
      vm: proxy,
    });
  }
}

// Lifecycle
onMounted(async () => {
  const params = {
    idTorneo: proxy.$route.params.id,
  };

  const { data } = await axios.get("/Torneos/GetTorneoById", { params });

  nombreLiga.value = data.nombre;
  categoriaLiga.value = data.categoria;
  generoLiga.value = data.genero;
  tipoCompetenciaLiga.value = data.tipoCompetencia;
  estadoLiga.value = data.estado;
  idLiga.value = data.idTorneo;
  idInstitucion.value = data.idInstitucion;
  deporte.value = data.deporte;

  infoLiga.value = `${nombreLiga.value} - Categoría: ${categoriaLiga.value} - Género: ${generoLiga.value}`;

  if (data.configuraciones) {
    const configuraciones = JSON.parse(data.configuraciones);
    liga.value = { ...configuraciones };
    totalEquipos.value = configuraciones.totalEquipos;
    await nextTick();
  }

  guardarInterval.value = setInterval(() => {
    if (hayCambiosSinGuardar.value && estadoLiga.value !== "Finalizado") {
      guardarCambios();
    }
  }, 30000);
});

onUnmounted(() => {
  clearInterval(guardarInterval.value);
});

watch(
  () => liga.value,
  (nuevaLiga) => {
    if (!ligaOriginal.value) {
      // Guardar copia inicial
      ligaOriginal.value = JSON.parse(JSON.stringify(nuevaLiga));
      hayCambiosSinGuardar.value = false;
      return;
    }

    // Comparar con la copia original
    const haCambiado =
      JSON.stringify(nuevaLiga) !== JSON.stringify(ligaOriginal.value);
    hayCambiosSinGuardar.value = haCambiado;

    console.log("¿Torneo modificado?", haCambiado);
  },
  { deep: true, immediate: true },
);
</script>
<style scoped lang="scss">
.liga-configurada {
  position: absolute;
  right: 1.1rem;
  border: 1px solid orange;
  border-radius: 5px;
  padding: 0.5rem 1rem;
  background: oldlace;
  color: black;
  font-size: 16px;
}
.tabla-partidos {
  :deep(.ganador-border) {
    color: green;
  }
  :deep(.perdedor-border) {
    color: red;
  }
}
</style>
